const date = new Date();

export const year = date.getFullYear();






// WEBPACK FOOTER //
// ./src/misc/helpers.js